// extracted by mini-css-extract-plugin
export default {"aboutbody":"about_aboutbody__wupfk","h1":"about_h1__-OsKe","content":"about_content__A8He8","aboutflex":"about_aboutflex__Bex5-","mail":"about_mail__5sXpZ"};